<template>
  <easy-page-template
      title="サイトに関して、何を行いますか？"
      subtitle="サイトに関して行うことを、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconSystemTerminalDocker"
          title="サイト認証キーの確認"
          @click="downloadDockerComposeYaml"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemTerminalCalendar"
          title="カレンダの管理"
          to="/edit/list/terminalImplementation/calendars"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemTerminalController"
          title="コントローラの管理"
          to="/edit/list/terminalImplementation/controllers"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconSystemTerminalDocker from "./assets/icon_system_terminal_docker.svg";
import iconSystemTerminalCalendar from "./assets/icon_system_terminal_calendar.svg";
import iconSystemTerminalController from "./assets/icon_system_terminal_controller.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";
import FileUtils from "@/utils/FileUtils";
import {mapGetters} from "vuex";

export default {
  name: "Terminal",
  mixins: [
    FileUtils
  ],
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconSystemTerminalDocker,
      iconSystemTerminalCalendar,
      iconSystemTerminalController,
      imageTradeContract
    }
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account'
    }),
    terminalId() {
      return this.account.user.terminalId;
    }
  },
  methods: {
    downloadDockerComposeYaml() {
      this.$store.dispatch('hcs/terminal/fetchDockerFile', this.terminalId)
          .then((response) => {
            this.downloadFile(response, 'docker-compose.yml')
          })
          .catch(() => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `認証ファイルのダウンロードに失敗しました`
            });
          })
    }
  }
}
</script>

<style scoped>

</style>
